var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{ref:"widgetHeader",staticClass:"widget-header"},[_c('filter-form',{on:{"scrolltop":_vm.handleScrollTop}}),_c('display-switch')],1)}
var staticRenderFns = []

export { render, staticRenderFns }